function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 28.5,
  cy: 28.5,
  r: 28.5,
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.5,
  cy: 28.5,
  r: 21.5,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.072 8.188a24.429 24.429 0 10-27.144 40.623A24.429 24.429 0 0042.072 8.188zm-24.181 10.49l6.8 9.233-8.318 11.165a3.811 3.811 0 00-.714 2.139 2.935 2.935 0 003.195 2.933 3.038 3.038 0 002.6-1.384l6.89-9.568 6.893 9.571a3.042 3.042 0 002.6 1.384 2.936 2.936 0 003.188-2.938 3.81 3.81 0 00-.723-2.139l-8.31-11.165 6.8-9.245a3.017 3.017 0 00-2.517-4.911 3.621 3.621 0 00-2.728 1.566l-5.205 7.388-5.205-7.363a3.583 3.583 0 00-2.728-1.566 3.012 3.012 0 00-2.518 4.9z",
  fill: "#000"
});

function SvgBenCloseActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 57"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NyA1NyI+PGNpcmNsZSBjeD0iMjguNSIgY3k9IjI4LjUiIHI9IjI4LjUiIGZpbGw9IiMwMDAiLz48Y2lyY2xlIGN4PSIyOC41IiBjeT0iMjguNSIgcj0iMjEuNSIgZmlsbD0iI2ZmZiIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNDIuMDcyIDguMTg4YTI0LjQyOSAyNC40MjkgMCAxMC0yNy4xNDQgNDAuNjIzQTI0LjQyOSAyNC40MjkgMCAwMDQyLjA3MiA4LjE4OHptLTI0LjE4MSAxMC40OWw2LjggOS4yMzMtOC4zMTggMTEuMTY1YTMuODExIDMuODExIDAgMDAtLjcxNCAyLjEzOSAyLjkzNSAyLjkzNSAwIDAwMy4xOTUgMi45MzMgMy4wMzggMy4wMzggMCAwMDIuNi0xLjM4NGw2Ljg5LTkuNTY4IDYuODkzIDkuNTcxYTMuMDQyIDMuMDQyIDAgMDAyLjYgMS4zODQgMi45MzYgMi45MzYgMCAwMDMuMTg4LTIuOTM4IDMuODEgMy44MSAwIDAwLS43MjMtMi4xMzlsLTguMzEtMTEuMTY1IDYuOC05LjI0NWEzLjAxNyAzLjAxNyAwIDAwLTIuNTE3LTQuOTExIDMuNjIxIDMuNjIxIDAgMDAtMi43MjggMS41NjZsLTUuMjA1IDcuMzg4LTUuMjA1LTcuMzYzYTMuNTgzIDMuNTgzIDAgMDAtMi43MjgtMS41NjYgMy4wMTIgMy4wMTIgMCAwMC0yLjUxOCA0Ljl6IiBmaWxsPSIjMDAwIi8+PC9zdmc+";
export { SvgBenCloseActive as ReactComponent };